/**
 * Exact browser-global coordination keys for owner replacement.
 *
 * Neither value carries authored or owner-derived content. The drain-failure
 * key stores only the transition UUID so the exclusive waiter can refuse a
 * replacement after another tab fails to persist its in-memory work. A stale
 * or malformed value under either exact key is therefore coordination state,
 * not evidence of protected content. Unknown `adia-*` keys remain outside
 * this list and must continue to fail closed.
 */
export const OWNER_TRANSITION_KEY = 'adia-owner-transition-v1';
export const OWNER_TRANSITION_DRAIN_FAILURE_KEY =
  'adia-owner-transition-drain-failure-v1';

export function isOwnerTransitionCoordinationKey(key: string): boolean {
  return key === OWNER_TRANSITION_KEY ||
    key === OWNER_TRANSITION_DRAIN_FAILURE_KEY;
}
